import "./styles/call.css";

export default function Call({ call, mediaRecorderRef }) {
  return (
    <div className="robot-speaking">
      {/* Left waves */}
      {call.isSpeaking ? (
        <div className="wave-container left">
          <div className="arc large "></div>
          <div className="arc medium "></div>
          <div className="arc small "></div>
        </div>
      ) : (
        // ):(mediaRecorderRef.state == "recording"  (
        <div className="listing-div">
          <span className="wave"></span>
          <span className="wave"></span>
          <span className="wave"></span>
        </div>
      )}

      {/* Robot icon */}
      <div style={{ fontSize: "58px", color: "#fff" }}>🤖</div>

      {/*  */}
      {call.isSpeaking ? (
        <div className="wave-container">
          <div className="arc small "></div>
          <div className="arc medium "></div>
          <div className="arc large "></div>
        </div>
      ) : (
        <div className="listing-div">
          <span className="wave"></span>
          <span className="wave"></span>
          <span className="wave"></span>
        </div>
      )}
    </div>
  );
}
